<template>
  <div>
    <div class="t bold">Bonus amount</div>
    <div class="f m-t">
      <div class="w-x10">
        <donut-input-async-number :model-value="defaultValue" class="full-width" @submit="onDefaultValueSubmit" />
      </div>
      <div class="t m-lx1">
        <span v-emoji="`:${pointsConfig.emoji}:`" />
        <span> = ${{ (defaultValue * state.pointsConfig.dollarsPerPoint).toFixed(2) }} per recipient</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, dispatch } = useStore();

  const pointsConfig = computed(() => state.pointsConfig.config);
  const config = computed(() => state.bonusMilestoneConfigs.anniversary);

  const defaultValue = computed(() => config.value.default_points);
  const onDefaultValueSubmit = (value, onComplete) => {
    const oldValue = defaultValue.value;
    if (value < 1 || parseInt(value) !== value) {
      onComplete({ value: oldValue, icon: 'error' });
      dispatch('setErrorToast', 'Value must be a whole number greater than 0.');
    } else {
      dispatch('bonusMilestoneConfigs/updateMilestoneConfig', { type: 'anniversary', params: { default_points: value } })
        .then(() => onComplete({ icon: 'success' }))
        .catch(() => {
          onComplete({ value: oldValue, icon: 'error' });
          dispatch('setErrorToast', 'Error updating the flat amount value.');
        });
    }
  };
</script>
